import type vtkImageData from '@kitware/vtk.js/Common/DataModel/ImageData';

import type { ContourProps } from './contour-definitions';
import type { Point, PointArray } from './types/contour-definition-array-type';

import { ContourBase, ContourType } from './contour-definitions';

import { snapPolyLineToSubPixelGrid } from './contour-processing/snapPolyLineToSubPixelGrid';

export class PointContour extends ContourBase {
  private _pointSi: number = 0;
  private _needSiRecalculation: boolean = true;

  constructor(
    props: Partial<ContourProps> & Pick<ContourProps, 'type' | 'label'>,
    polygon: PointArray = [],
  ) {
    super(props);

    if (
      props.type !== ContourType.PointContour
      && props.type !== ContourType.AnnotationTextContour
    ) {
      throw new Error('PointContour - Invalid contour type');
    }
    this.setPolygonScaled(polygon);
  }

  private resetSignalIntensityPoint() {
    this._pointSi = 0;
    this._needSiRecalculation = true;
  }

  public isValid() {
    if (this._polygon.length >= 1) return true;
    return false;
    // return (
    //     this._polygon[0].x > -1
    // && this._polygon[0].y !== this._polygon[1].y);
  }

  public setPolygon(polygon: PointArray): void {
    this._polygon = polygon;
    this.resetSignalIntensityPoint();
  }

  public setPolygonScaled(polygon: PointArray): void {
    // todo review

    polygon = snapPolyLineToSubPixelGrid(polygon, false);

    this._polygon = [];
    this.resetSignalIntensityPoint();

    this._polygon = Array.from({ length: polygon.length });
    for (let i = 0; i < polygon.length; i++) {
      this._polygon[i] = {
        x: polygon[i].x * ContourBase.subMatrix,
        y: polygon[i].y * ContourBase.subMatrix,
      };
    }
  }

  public getPolygonScaled(): PointArray {
    const polygon = Array.from<Point>({ length: this._polygon.length });
    for (let i = 0; i < polygon.length; i++) {
      polygon[i] = {
        x: this._polygon[i].x / ContourBase.subMatrix,
        y: this._polygon[i].y / ContourBase.subMatrix,
      };
    }
    return polygon;
  }

  public getCentroid() {
    return this.getPolygon()[0];
  }

  public getCentroidScaled() {
    return this.getPolygonScaled()[0];
  }

  public getPointSi(imageData: vtkImageData | undefined = this.getVtKImageData()): number {
    if (this._needSiRecalculation) {
      if (!imageData) {
        return this._pointSi;
      }
      const polygonScaled = this.getPolygonScaled();
      if (!polygonScaled || !polygonScaled.length) {
        return this._pointSi;
      }
      const imgPix = {
        x: Math.abs(polygonScaled[0].x),
        y: Math.abs(polygonScaled[0].y),
      };
      const si = this.getPixelSignalIntensity(imageData, imgPix);
      if (si !== undefined && !Number.isNaN(si)) {
        this._pointSi = si;
        this._needSiRecalculation = false;
      }
    }
    return this._pointSi;
  }
}
